import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface FixedThinSidebarProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  className?: string;
}

export const FixedThinSidebar = ({
  children,
  className,
  ...rest
}: FixedThinSidebarProps) => (
  <div
    className={classNames(
      "text-default bg-primary border-primary z-10 h-full w-16 border-r p-4",
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);
